import {
    apiCreateMarkersOfHarmRequest,
    ApiCreateMarkersOfHarmResponseType,
    ApiCreateMarkersOfHarmParamsType,
} from 'src/api_openapi/v2/markersOfHarm/apiCreateMarkersOfHarm';
import {
    apiDeleteMarkersOfHarmRequest,
    ApiDeleteMarkersOfHarmResponseType,
    ApiDeleteMarkersOfHarmParamsType,
} from 'src/api_openapi/v2/markersOfHarm/apiDeleteMarkersOfHarm';
import {
    apiGetMarkersOfHarmListRequest,
    ApiGetMarkersOfHarmListResponseType,
    ApiGetMarkersOfHarmListParamsType,
} from 'src/api_openapi/v2/markersOfHarm/apiGetMarkersOfHarmList';
import {
    apiUpdateMarkersOfHarmRequest,
    ApiUpdateMarkersOfHarmResponseType,
    ApiUpdateMarkersOfHarmParamsType,
} from 'src/api_openapi/v2/markersOfHarm/apiUpdateMarkersOfHarm';
import { Common } from 'src/AppState/Common';

export class ApiMarkersOfHarm {
    public constructor(private readonly common: Common) {}

    public createMarkersOfHarm(params: ApiCreateMarkersOfHarmParamsType): Promise<ApiCreateMarkersOfHarmResponseType> {
        return apiCreateMarkersOfHarmRequest(`${this.common.appEnvParams.gatewayUrl}`, params, {
            // traceparent: undefined,
            // tracestate: undefined,
            authorization: `Bearer ${this.common.session.currentJwt}`,
        });
    }

    public deleteMarkersOfHarm(params: ApiDeleteMarkersOfHarmParamsType): Promise<ApiDeleteMarkersOfHarmResponseType> {
        return apiDeleteMarkersOfHarmRequest(`${this.common.appEnvParams.gatewayUrl}`, params, {
            // traceparent: undefined,
            // tracestate: undefined,
            authorization: `Bearer ${this.common.session.currentJwt}`,
        });
    }

    public getListMarkersOfHarm(
        params: ApiGetMarkersOfHarmListParamsType
    ): Promise<ApiGetMarkersOfHarmListResponseType> {
        return apiGetMarkersOfHarmListRequest(`${this.common.appEnvParams.gatewayUrl}`, params, {
            // traceparent: undefined,
            // tracestate: undefined,
            authorization: `Bearer ${this.common.session.currentJwt}`,
        });
    }
    public patchMarkersOfHarm(params: ApiUpdateMarkersOfHarmParamsType): Promise<ApiUpdateMarkersOfHarmResponseType> {
        return apiUpdateMarkersOfHarmRequest(`${this.common.appEnvParams.gatewayUrl}`, params, {
            // traceparent: undefined,
            // tracestate: undefined,
            authorization: `Bearer ${this.common.session.currentJwt}`,
        });
    }
}
